import { defineMessages } from 'react-intl';

const messages: {
	cardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	startDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnDurationLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnDurationValue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	numberOfColumnsLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	cardTitle: {
		id: 'conversation-assistant-message-actions.add-program-board.card-title',
		defaultMessage: 'Create program board',
		description: 'Title for the create program board action card',
	},
	startDateLabel: {
		id: 'conversation-assistant-message-actions.add-program-board.start-date-label',
		defaultMessage: 'Start date',
		description:
			'Label shown next to the start date input field in the add program board dialog for Jira Plans',
	},
	columnDurationLabel: {
		id: 'conversation-assistant-message-actions.add-program-board.column-duration-label',
		defaultMessage: 'Column duration',
		description:
			'Label shown next to the column duration input field in the add program board dialog for Jira Plans, indicating how long each board column spans',
	},
	columnDurationValue: {
		id: 'conversation-assistant-message-actions.add-program-board.column-duration-value',
		defaultMessage: '{count, plural, one {# week} other {# weeks}}',
		description: 'Column duration value with week/weeks plural',
	},
	numberOfColumnsLabel: {
		id: 'conversation-assistant-message-actions.add-program-board.number-of-columns-label',
		defaultMessage: 'Number of columns',
		description:
			'Label shown next to the number of columns input field in the add program board dialog for Jira Plans',
	},
	confirmButton: {
		id: 'conversation-assistant-message-actions.add-program-board.confirm-button',
		defaultMessage: 'Create',
		description:
			'Text on the confirm button in the add program board dialog for Jira Plans. Clicking it submits the form and creates the new program board',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.add-program-board.cancel-button',
		defaultMessage: 'Cancel',
		description:
			'Text on the cancel button in the add program board dialog for Jira Plans. Dismisses the dialog without creating a board',
	},
});

export default messages;
